module.exports = __webpack_public_path__ + "static/img/aboutUs_img03.12568ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/aboutUs_img03.png
// module id = DStR
// module chunks = 1